import {inject, Injectable} from '@angular/core';
import { ProductCardsDefectsApiService } from '../services-api/product-cards-defects-api.service';
import {RecordsDataRequestQueryParams} from "../../../../core/types/records-table.types";
import {
  CreateProductCardsDefectParams,
  ProductCardDefect,
  UpdateProductCardsDefectParams
} from "../types/product-card-defect.types";

@Injectable({
  providedIn: 'root'
})
export class ProductCardsDefectsService {
  private productCardsDefectsApiService: ProductCardsDefectsApiService = inject(ProductCardsDefectsApiService);

  public getProductCardsDefects(queryParams: RecordsDataRequestQueryParams): Promise<Array<ProductCardDefect>> {
    return new Promise((resolve, reject) => {
      this.productCardsDefectsApiService.getProductCardsDefects(queryParams).subscribe({
        next: (productCardDefects) => resolve(productCardDefects),
        error: (error) => reject(error)
      });
    });
  }

  public createProductCardsDefect(createProductCardsDefectParams: CreateProductCardsDefectParams): Promise<ProductCardDefect> {
    return new Promise((resolve, reject) => {
      this.productCardsDefectsApiService.createProductCardsDefect(createProductCardsDefectParams).subscribe({
        next: (productCardDefect) => resolve(productCardDefect),
        error: (error) => reject(error)
      });
    });
  }

  public updateProductCardsDefect(updateProductCardsDefectParams: UpdateProductCardsDefectParams): Promise<ProductCardDefect> {
    return new Promise((resolve, reject) => {
      this.productCardsDefectsApiService.updateProductCardsDefect(updateProductCardsDefectParams).subscribe({
        next: (productCardDefect) => resolve(productCardDefect),
        error: (error) => reject(error)
      });
    });
  }

  public deleteProductCardsDefect(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardsDefectsApiService.deleteProductCardsDefect(id).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
